<template>
  <div>
    <div class="edit-bar">
      <div class="edit-bar__left">
        <el-select
            class="select"
            v-model="value"
            placeholder="Выберите действие"
            clearable
        >
          <el-option
              v-for="item in optionsList"
              :key="item.id"
              :label="`${item.title}`"
              :value="item.id"
          >
            <span style="float: left">{{ item.title }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{sign}}{{ item.amount }}H₵</span>
          </el-option>
        </el-select>
      </div>

      <div class="edit-bar__right">
        <div :class="['cost_value', `cost_value__${typeItem}`]">{{ sign }} {{ cost }}H₵</div>
      </div>
    </div>

    <div class="btn">
      <el-button
          type="primary"
          @click="edit"
          :loading="loading">{{ btnTitle }}
      </el-button>
      <el-button
          v-if="currentTime !== 0"
          @click="cancel"
          :loading="loading"
      >Отменить последнее списание {{ currentTime }} сек
      </el-button>
    </div>

  </div>
</template>
<script>
export default {
  name: "EditLoyalty",
  data() {
    return {
      value: '',
      loading: false,
      showCancel: false,
      currentTime: 0,
      timerCode: null,
      historyId: null,
    }
  },
  props: {
    typeItem: {
      required: true
    },
    user: {
      required: true
    },
    options: {
      required: true,
    }
  },
  watch: {
    currentTime(time) {
      if (time <= 0) {
        this.stopTimer();
      }
    },
  },
  computed: {
    optionsList() {

      return this.options.filter(item => (item.type === this.typeItem && item.execution === "operator"))
    },
    cost() {
      let cost = this.options.filter(item => item.id === this.value)
      return cost[0] ? cost[0].amount : '...'
    },
    btnTitle() {
      return this.typeItem === 'decrease' ? 'Списать' : 'Начислить'
    },
    sign() {
      return this.typeItem === 'decrease' ? '-' : '+'
    }
  },
  methods: {
    edit() {
      if(!this.value) {
        return this.$notify.warning({
          title: "Выберите действие!",
          message: "Нужно выбрать действие",
        });

      }

      this.stopTimer()

      this.loading = true
      this.$api.loyalty.change(this.user.id, {action_id: this.value})
          .then((response) => {

            this.$notify.success({
              title: "Удачно!",
              message: "Опреация произведена",
            });
            this.$emit("reloadHistory", this.typeItem)

            this.historyId = response.data.id
            this.startTimer()

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка изменения 😕",
              message: response.response.data.message,
            });

          })
          .finally(() => {
            this.loading = false
          });

    },
    startTimer() {
      this.currentTime = 60

      this.timerCode = setInterval(() => {
        this.currentTime--;
      }, 1000);
    },
    stopTimer() {
      clearTimeout(this.timerCode);
      this.currentTime = 0
    },
    cancel() {
      this.loading = true
      this.$api.loyalty.delete(this.user.id, this.historyId)
          .then(() => {

            this.$notify.success({
              title: "Удачно!",
              message: "Отменено",
            });
            this.stopTimer()
            this.$emit("reloadHistory", this.typeItem)

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка изменения 😕",
              message: response.response.data.message,
            });

          })
          .finally(() => {
            this.loading = false
          });

    }
  }
}
</script>
<style lang="scss" scoped>
.edit-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;

  &__left {
    flex: 1;
  }

  &__right {
    width: 70px;
  }

}

.select {


  display: block;
  width: 100%;
}

.cost_value {
  width: max-content;
  margin: 0 auto;

  padding: 5px 8px;

  background: #CCF9EF;
  border-radius: 4px;

  font-weight: 500;
  font-size: 12px;
  line-height: 13px;
  text-align: center;

  color: #111;

  &__decrease {
    background: #FFD8D8;
  }

  &__increase {
    background: #CCF9EF;
  }
}

.btn {
  margin-top: 16px;
}


</style>
